// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as StylableElement$Showside from "./StylableElement.bs.js";
import * as ProductDetailsConfig$Showside from "../types/ProductDetailsConfig.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ProductDetailsContext$Showside from "../context/ProductDetailsContext.bs.js";
import * as ProductDetailsConfigId$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/ProductDetailsConfigId.bs.js";
function ProductBadges$Badge(Props) {
  var badge = Props.badge;
  var children = Props.children;
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "product-badge",
    dataId: Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.toString, badge.id),
    children: React.createElement("div", undefined, children)
  });
}
ProductBadges$Badge.displayName = "ProductBadges.Badge";
var make = React.memo(ProductBadges$Badge);
var Badge = {
  make: make
};
function getBadgeKey(badge, product, variant) {
  var badgeId = Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.toString, badge.id);
  if (variant !== undefined) {
    return badgeId + product.id + variant.id;
  } else {
    return badgeId + product.id;
  }
}
function ProductBadges(Props) {
  var className = Props.className;
  var dataTestId = Props.dataTestId;
  var style = Props.style;
  var sizeOpt = Props.size;
  var product = Props.product;
  var variant = Props.variant;
  var size = sizeOpt !== undefined ? sizeOpt : /* Md */0;
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var pdpConfig = ProductDetailsContext$Showside.use(undefined);
  var className$1 = Cn.make([Belt_Option.getWithDefault(className, ""), StylableElement$Showside.toString("product-card__badge-box"), CSS$Showside.prefix("flex flex-wrap items-start justify-start"), size ? CSS$Showside.prefix("gap-1") : CSS$Showside.prefix("gap-3")]);
  var badges = Belt_Array.map(Belt_Array.keepMap(Belt_Array.keep(pdpConfig.badges, function (badge) {
    return ProductDetailsConfig$Showside.isVisible(product, variant, badge.visible);
  }), function (badge) {
    var style = {
      backgroundColor: badge.backgroundColor,
      color: badge.textColor,
      lineHeight: "normal"
    };
    var className = Cn.make([StylableElement$Showside.toString("product-card__badge"), CSS$Showside.prefix("rounded-custom leading-normal"), size ? CSS$Showside.prefix("text-base px-2 py-0.5") : CSS$Showside.prefix("text-lg px-2 py-1")]);
    return Belt_Option.map(ProductDetailsConfig$Showside.Content.renderContent(Caml_option.some(style), className, product, variant, config, badge.content), function (content) {
      return [content, badge];
    });
  }), function (param) {
    var badge = param[1];
    return React.createElement(make, {
      badge: badge,
      children: param[0],
      key: getBadgeKey(badge, product, variant)
    });
  });
  if (badges.length === 0) {
    return null;
  }
  var tmp = {
    "aria-label": "product badges",
    className: className$1
  };
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  var tmp$1 = {
    children: React.createElement("div", tmp, badges)
  };
  if (dataTestId !== undefined) {
    tmp$1.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  return React.createElement(DataAttribute$Showside.make, tmp$1);
}
ProductBadges.displayName = "ProductBadges";
var make$1 = React.memo(ProductBadges);
export { Badge, getBadgeKey, make$1 as make };
/* make Not a pure module */